export const OTP_VERIFY_FIELD_LABEL = 'Please enter your one-time passcode';
export const EMAIL_FIELD_EMPTY_LABEL = 'Please enter your email address';
export const EMAIL_FIELD_VALIDATION_LABEL = 'Please provide a valid email address';
